import React from 'react';
import UserStaticInformation from './UserStaticInformation';
import { CaseCreationStaticSchema } from '../CreateCaseSchema';
import isEmpty from 'lodash/isEmpty';

export interface UserStaticInfoSectionProps {
  schema?: CaseCreationStaticSchema;
  properties?: {
    [attribute: string]: string;
  };
}
const UserStaticInfoSection: React.FC<UserStaticInfoSectionProps> = ({
  schema,
  properties = {},
}) => {
  if (isEmpty<CaseCreationStaticSchema>(schema)) {
    return <></>;
  }
  return <UserStaticInformation store={properties} schema={schema} />;
};

export default UserStaticInfoSection;
